import { render, staticRenderFns } from "./UserOnly.vue?vue&type=template&id=1991457f&scoped=true&"
import script from "./UserOnly.vue?vue&type=script&lang=js&"
export * from "./UserOnly.vue?vue&type=script&lang=js&"
import style0 from "./UserOnly.vue?vue&type=style&index=0&id=1991457f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991457f",
  null
  
)

export default component.exports